import { app } from '../../../app';

app.factory('SaaspassConnectService', SaaspassConnectService);

/** @ngInject */
function SaaspassConnectService($resource) {
    return $resource('app/rest/admin/company/:companyId/saaspassconnects', {
        companyId : '@companyId'
    }, {
        'applyPolicy' : {
            method : 'PUT',
            url : 'app/rest/admin/company/:companyId/saaspassconnects/:id/:policyId',
            params : {
                id : '@id',
                policyId: '@policyId'
            },
            isArray : true
        }
    });
}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/saaspass-connect.service.js